import { STORAGE_KEYS } from '../config/storageKeys';

export const ensureProjectPanelToggle = (app: HTMLElement): HTMLButtonElement => {
  let toggleBtn = document.querySelector('.panel-toggle') as HTMLButtonElement | null;
  if (!toggleBtn) {
    toggleBtn = document.createElement('button');
    toggleBtn.className = 'panel-toggle';
    toggleBtn.title = 'Toggle Projects Panel';
    toggleBtn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>`;
    document.body.appendChild(toggleBtn);
  }

  const isCollapsed = localStorage.getItem(STORAGE_KEYS.panelCollapsed) === 'true';
  app.classList.toggle('panel-collapsed', isCollapsed);
  toggleBtn.classList.toggle('collapsed', isCollapsed);

  if (!toggleBtn.dataset.bound) {
    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const nowCollapsed = app.classList.toggle('panel-collapsed');
      toggleBtn!.classList.toggle('collapsed');
      localStorage.setItem(STORAGE_KEYS.panelCollapsed, String(nowCollapsed));
    });
    toggleBtn.dataset.bound = 'true';
  }

  return toggleBtn;
};
